import { getNumberOfHouseholdsAndDensityForBoundaries } from '../../Utils/Map'
import {
  getPolygonAreaInKm2,
  getTimeNeededForFlyersDistribution,
} from '../../shared/libraries/geo'
import { timeConvert } from '../../shared/libraries/utils/date.js'
/**
 * Gets boundary from GMAP overlay object
 * @param {Object} overlay GMAP Overlay
 *
 * @returns {Array<Object>} Array of boundary points
 */
export const getOverlayBoundary = overlay => {
  let boundary = []
  overlay.getPath().forEach(item => {
    boundary.push({
      latitude: item.lat(),
      longitude: item.lng(),
    })
  })
  return boundary
}

/**
 * Makes call to the PathFinder service and adds area info to the passed overlay,
 * @param {Object} overlay GMAP Overlay that we want to update
 */
export const getAreaData = async (overlay, countryCode) => {
  const boundary = getOverlayBoundary(overlay)

  const [
    { householdsAmount, density },
  ] = await getNumberOfHouseholdsAndDensityForBoundaries({
    boundaries: [boundary],
    countryCode,
  })
  const polygonAreaSize = getPolygonAreaInKm2(boundary)

  const aproximateDistTime = getTimeNeededForFlyersDistribution({
    areaSize: polygonAreaSize,
    householdsAmount: householdsAmount,
  })

  return [
    {
      name: 'Addresses',
      value: householdsAmount,
    },
    {
      name: 'Density',
      value: `${density} HH/km2`,
    },
    {
      name: 'Area Size',
      value: `${polygonAreaSize.toFixed(3)} km2`,
    },
    {
      name: 'Approximate dist time',
      value: timeConvert(aproximateDistTime * 60),
    },
  ]
}

/**
 * GMap's getBounds returns LatLngBound that contains only NW and SW points of the map's view
 * This function formats it to the real rectangle
 * @param {GMAP.LatLngBound} latLngBound
 * @returns {array} Coords of rectangle
 */
export const getAreaFromLatLngBound = latLngBound => {
  const NE = latLngBound.getNorthEast()
  const SW = latLngBound.getSouthWest()

  const latitudeNE = NE.lat()
  const longitudeNE = NE.lng()
  const latitudeSW = SW.lat()
  const longitudeSW = SW.lng()

  return [
    {
      latitude: latitudeNE,
      longitude: longitudeNE,
    },
    {
      latitude: latitudeNE,
      longitude: longitudeSW,
    },
    {
      latitude: latitudeSW,
      longitude: longitudeSW,
    },
    {
      latitude: latitudeSW,
      longitude: longitudeNE,
    },
  ]
}

/**
 * Calculate modal position using current cursor's position
 * @param {object} cursorPosition Current cursor's position
 * @returns {object} Modal offset styles
 */
export const generateModalExtraStyles = cursorPosition => {
  if (cursorPosition && cursorPosition.left) {
    const wrapper = document.querySelector('.GMapRoot')
    const offset =
      wrapper.getBoundingClientRect().left -
      document.body.getBoundingClientRect().left
    const horizontalCenter = wrapper.clientWidth / 2
    const position = cursorPosition.left - offset

    return position < horizontalCenter ? { right: '60px' } : { left: '20px' }
  } else {
    return { left: '20px' }
  }
}

export const quartile = (data, q) => {
  const pos = (data.length - 1) * q // i = (n - 1) * p
  const base = Math.floor(pos)
  const rest = pos - base
  if (data[base + 1] !== undefined) {
    return data[base] + rest * (data[base + 1] - data[base])
  } else {
    return data[base]
  }
}

export const getFilters = densities => {
  const sortedData = [
    ...densities.sort((a, b) => {
      if (typeof a !== 'number') {
        return -1
      }

      if (typeof b !== 'number') {
        return 1
      }
      return a - b
    }),
  ]

  const low = quartile(sortedData, 1 / 3)
  const medium = quartile(sortedData, 2 / 3)
  return {
    low: [0, low],
    medium: [low, medium],
    high: [medium, Infinity],
  }
}

export const getDensities = overlays =>
  overlays.reduce((acc, overlay) => {
    if ('areaData' in overlay) {
      const [density] = overlay.areaData
        .find(item => item.name === 'Density')
        .value.split(' ')
      acc.push(isNaN(+density) ? 0 : +density)
    } else {
      acc.push(0)
    }
    return acc
  }, [])



// WEBPACK FOOTER //
// ./src/Components/DrawMap/util.js